import { useLazyQuery } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { getCookies } from '../../utils/common';
import { LITE_PROFILE } from '../queries';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return {
    getLiteProfile: {
      loyaltyData: bffResponse?.loyaltyData,
      creationDate: bffResponse?.creationDate,
      loyaltyPoints: bffResponse?.loyaltyPoints,
      loyaltyTier: bffResponse?.loyaltyTier,
    },
  };
}

export default function useLiteProfile(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useLazyQuery(LITE_PROFILE, options);
  const [restExecute, restState] = useAsyncCall(
    () =>
      restRequest({
        path: '/air-api/v1/profile/lite',
        headers: { 'access-token': getCookies('accessToken') },
      }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
